import { Builder } from '@builder.io/react';
import { CompanyStats } from './CompanyStats';

Builder.registerComponent(CompanyStats, {
  name: 'CompanyStats',
  image: 'https://cdn.builder.io/api/v1/image/assets%2FYJIGb4i01jvw0SRdL5Bt%2F3f6d3bc814ffd47b182ec8345cc5438c0',
  inputs: [
    {
      name: 'title',
      type: 'string',
      defaultValue: 'Global Trade Excellence',
      helperText: 'Main section title',
    },
    {
      name: 'subtitle',
      type: 'string',
      defaultValue: 'Delivering agricultural commodities and infrastructure solutions across West Africa',
      helperText: 'Subtitle text below the title',
    },
    {
      name: 'eyebrow',
      type: 'string',
      defaultValue: 'Our Operations',
      helperText: 'Small text above the title',
    },
    {
      name: 'showRiceImport',
      type: 'boolean',
      defaultValue: true,
      helperText: 'Show Rice Import section',
    },
    {
      name: 'showRiceReExport',
      type: 'boolean',
      defaultValue: true,
      helperText: 'Show Rice Re-Export section',
    },
    {
      name: 'showFertilizer',
      type: 'boolean',
      defaultValue: true,
      helperText: 'Show Fertilizer section',
    },
    {
      name: 'showInfrastructure',
      type: 'boolean',
      defaultValue: true,
      helperText: 'Show Infrastructure section',
    },
    {
      name: 'showPetroleum',
      type: 'boolean',
      defaultValue: true,
      helperText: 'Show Petroleum & Energy section',
    },
  ],
});
